import React from 'react';

const ConfigHeader = ({ saveMessage }) => {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Mobile App Configuration</h1>
        <p className="text-muted-foreground text-sm mt-1">
          Control PWA settings and per-platform screen visibility for iOS and Android
        </p>
      </div>
      {saveMessage && (
        <div
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium ${
            saveMessage?.type === 'success' ?'bg-green-50 text-green-700 border border-green-200' :'bg-red-50 text-red-700 border border-red-200'
          }`}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
            {saveMessage?.type === 'success' ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            )}
          </svg>
          {saveMessage?.text}
        </div>
      )}
    </div>
  );
};

export default ConfigHeader;
